import { useMemo, useState } from "react";
import { timelineData, timelineTags, years } from "../../../mocks/fortyone";

export default function TimelineSection() {
  const [year, setYear] = useState("全部");
  const [tag, setTag] = useState("全部");

  const list = useMemo(() => {
    return timelineData
      .filter((d) => (year === "全部" ? true : d.year === year))
      .filter((d) => (tag === "全部" ? true : d.tag === tag))
      .sort((a, b) =>
        a.year === b.year ? b.month.localeCompare(a.month) : b.year.localeCompare(a.year)
      );
  }, [year, tag]);

  return (
    <section id="timeline" className="py-16 md:py-24 bg-background-50 scroll-mt-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-semibold tracking-wide whitespace-nowrap">
            <i className="ri-time-line"></i>
            历史时间线汇总
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mt-4">
            按事件顺序，把脉络摊开给你看
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            支持按年份与主题筛选，逐条回看每个话题从发酵到收尾的关键节点。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <div className="inline-flex items-center gap-1 p-1 bg-background-100 rounded-full">
            {years.map((y) => (
              <button
                key={y}
                type="button"
                onClick={() => setYear(y)}
                className={`px-4 py-1.5 text-xs font-medium rounded-full whitespace-nowrap transition-colors cursor-pointer ${
                  year === y
                    ? "bg-foreground-950 text-background-50"
                    : "text-foreground-600 hover:text-foreground-950"
                }`}
              >
                {y}
              </button>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {timelineTags.map((t) => (
              <button
                key={t}
                type="button"
                onClick={() => setTag(t)}
                className={`px-3 py-1.5 text-xs font-medium rounded-full border whitespace-nowrap transition-colors cursor-pointer ${
                  tag === t
                    ? "bg-secondary-500 text-background-50 border-secondary-500"
                    : "border-background-300 text-foreground-600 hover:border-primary-400 hover:text-primary-700"
                }`}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 relative max-w-3xl mx-auto">
          <span className="absolute left-[9px] md:left-[13px] top-2 bottom-2 w-px bg-background-300"></span>
          <div className="flex flex-col gap-0">
            {list.map((d, i) => (
              <article key={`${d.year}-${d.month}-${i}`} className="relative pl-10 md:pl-14 pb-8">
                <span className="absolute left-0 md:left-1 top-2 w-5 h-5 md:w-7 md:h-7 flex items-center justify-center rounded-full bg-background-50 border-2 border-primary-500">
                  <span className="w-1.5 h-1.5 rounded-full bg-primary-500"></span>
                </span>
                <div className="flex flex-wrap items-center gap-2">
                  <span className="font-heading text-sm md:text-base font-bold text-primary-600 whitespace-nowrap">
                    {d.year}.{d.month}
                  </span>
                  <span className="px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-800 text-xs font-medium whitespace-nowrap">
                    {d.tag}
                  </span>
                  <span className="px-2.5 py-0.5 rounded-full bg-background-100 text-foreground-500 text-xs whitespace-nowrap">
                    {d.series}
                  </span>
                </div>
                <h3 className="mt-2 text-base md:text-lg font-bold text-foreground-950">{d.title}</h3>
                <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed">{d.summary}</p>
              </article>
            ))}
          </div>
          {list.length === 0 && (
            <p className="text-center text-foreground-400 text-sm py-10">该筛选条件下暂无内容，试试切换年份或主题。</p>
          )}
        </div>
      </div>
    </section>
  );
}